class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);
    if (this.classList.contains('sticky-cart-wrapper')) {
      const candidates = document.querySelectorAll('.product-form__buttons .product-form__submit');
      this.triggerElement = Array.from(candidates).find(
        (btn) => !btn.closest('.sticky-cart-wrapper')
      );
    }

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    let triggerPoint;
    if (this.triggerElement) {
      triggerPoint = this.getOffsetTop(this.triggerElement) + this.triggerElement.offsetHeight;
    } else {
      triggerPoint = this.getOffsetTop(this) - 300;
    }

    if (scrollTop > triggerPoint) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}

customElements.define('animate-sticky', AnimateSticky);

